/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShoptetWebhookRequest
 */
export interface ShoptetWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof ShoptetWebhookRequest
     */
    event?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoptetWebhookRequest
     */
    eventInstance?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoptetWebhookRequest
     */
    eshopId?: number;
}

/**
 * Check if a given object implements the ShoptetWebhookRequest interface.
 */
export function instanceOfShoptetWebhookRequest(value: object): value is ShoptetWebhookRequest {
    return true;
}

export function ShoptetWebhookRequestFromJSON(json: any): ShoptetWebhookRequest {
    return ShoptetWebhookRequestFromJSONTyped(json, false);
}

export function ShoptetWebhookRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShoptetWebhookRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'event': json['event'] == null ? undefined : json['event'],
        'eventInstance': json['eventInstance'] == null ? undefined : json['eventInstance'],
        'eshopId': json['eshopId'] == null ? undefined : json['eshopId'],
    };
}

export function ShoptetWebhookRequestToJSON(json: any): ShoptetWebhookRequest {
    return ShoptetWebhookRequestToJSONTyped(json, false);
}

export function ShoptetWebhookRequestToJSONTyped(value?: ShoptetWebhookRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event': value['event'],
        'eventInstance': value['eventInstance'],
        'eshopId': value['eshopId'],
    };
}

